import {RECRUITMENT_TYPE_KEYS} from '../../core/entities/recruitment/constants';
import type {RecruitmentDetailResponse} from '../../core/entities/recruitment/schema';

// Google の employmentType は大文字小文字を区別する。イベント系は求人ではないため対象外
const EMPLOYMENT_TYPES: Record<string, string> = {
  [RECRUITMENT_TYPE_KEYS.SELECTION]: 'FULL_TIME',
  [RECRUITMENT_TYPE_KEYS.INTERN]: 'INTERN',
};

export const createJobPostingStructuredData = (
  recruitmentDetail: Pick<
    RecruitmentDetailResponse,
    'title' | 'resources' | 'modifiedAt' | 'displayEndAt' | 'typeV2'
  >,
  recruitmentDetailId: number,
  companyName: string,
  companyLogoImageUrl: string,
) => {
  const employmentType = EMPLOYMENT_TYPES[recruitmentDetail.typeV2.key];
  if (!employmentType) return null;

  // 構造化データ https://developers.google.com/search/docs/appearance/structured-data/job-posting?hl=ja
  const structuredData = [
    {
      '@context': 'https://schema.org',
      '@type': 'JobPosting',
      title: recruitmentDetail.title,
      description: recruitmentDetail.resources[0]?.content,
      identifier: {
        '@type': 'PropertyValue',
        name: companyName,
        value: recruitmentDetailId,
      },
      datePosted: recruitmentDetail.modifiedAt,
      validThrough: recruitmentDetail.displayEndAt,
      employmentType,
      jobLocation: {
        '@type': 'Place',
        address: {
          '@type': 'PostalAddress',
          addressCountry: 'JP',
        },
      },
      hiringOrganization: {
        '@type': 'Organization',
        name: companyName,
        logo: companyLogoImageUrl,
      },
    },
  ];
  return structuredData;
};
